<div class="f-row custom-dialog">
  <div class="container d-justify-bw">
    <div class="verify-title">
      <div class="title">
        <h3 class="title-text">
          {{ content?.warningList[1]?.title }}
        </h3>
        <span class="sub-title"
          >{{
            (content?.warningList[1]?.subTitle).replace(
              "email: {email}",
              "email: "
            )
          }}
          ram<span class="title-variable">..........travog.com</span></span
        >
      </div>

      <div class="close">
        <button mat-icon-button>
          <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
        </button>
      </div>
    </div>
    <form>
      <div class="f-col d-align-center verify-body">
        <div class="f-col app-input-100w">
          <mat-form-field>
            <mat-label>Enter code</mat-label>
            <input matInput />
          </mat-form-field>
        </div>
        <span class="sub-title"
          >Resend code in <span class="title-variable">00:59</span></span
        >
        <span class="sub-title p-top-6x"
          >You have <span class="title-variable">3</span> attempts left.</span
        >
      </div>
      <div class="f-col d-align-right verify-footer">
        <button mat-button class="button--primary-small">
          {{ content?.warningList[1]?.confirmCTAText }}
        </button>
      </div>
    </form>
  </div>
</div>
